const footer_select = document.querySelector('#form-field-field_5b0a6ed');

footer_select.addEventListener( "change", function () {
    this.options[this.selectedIndex].value && (window.location = this.options[this.selectedIndex].value);
});

let popup_close = document.querySelector( '#popup_close' );

popup_close.addEventListener( 'click', function ( e ) {
    e.preventDefault();
    let footer_popup = document.querySelector('#footer-popup-container');
    
    setCookie('popup_cookie','active',30);

    if ( 'none' != footer_popup.style.display ) {
        footer_popup.classList.add('hidden');
        setTimeout( function () {
            footer_popup.style.display = 'none';
        }, 1000 );
    }
});

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

